<script setup lang="ts">
import type { IconName } from '../WheelsSvgIcon/WheelsSvgIcon.types'
import WheelsSvgIcon from '../WheelsSvgIcon/WheelsSvgIcon.vue'

withDefaults(defineProps<{
  variant?: 'primary' | 'secondary' | 'link' | 'plain'
  icon?: IconName
  iconPosition?: 'left' | 'right'
  disabled?: boolean
}>(), {
  variant: 'primary',
  iconPosition: 'left',
  disabled: false
})

const emit = defineEmits<{
  (e: 'click', event:MouseEvent): void
}>()

function handleClick(event:MouseEvent) {
  emit('click', event)
}

</script>

<template>
  <button
  class="wheels-button"
  :disabled="disabled"
  @click="handleClick"
  :class="{
    'wheels-button__primary': variant === 'primary',
    'wheels-button__secondary': variant === 'secondary',
    'wheels-button__link': variant === 'link',
    'wheels-button__plain': variant === 'plain',
    'wheels-button__icon': icon !== undefined,
    'wheels-button__icon-left': icon !== undefined && iconPosition === 'left',
    'wheels-button__icon-right': icon !== undefined && iconPosition === 'right',
  }"
  >
    <span class="wheels-button__content">
      <WheelsSvgIcon class="wheels-button__icon" v-if="icon" :icon="icon" size="1rem" />
      <slot></slot>
    </span>
  </button>
</template>